import { useState, useEffect } from "react";
import { projectFirestore } from "components/ProjectFirestore";

const UserName = (email) => {
  const [name, setName] = useState("");

  useEffect(async () => {
    if (email)
      try {
        const docRef = projectFirestore.collection("users").doc(email);

        const docValue = await docRef.get();
        if (docValue.exists) {
          if (docValue.data().name !== "") setName(docValue.data().name);
        }
      } catch (error) {
        console.error(error);
      }
  }, [email]);
  return name;
};
export default UserName;
